import { type GuardStatus, useCurrenciesQuery } from '@capsicum/common';
import { useMemo } from 'react';

type UseV2MigrationGuardStatusProps = {
	currencyId?: string;
	isMigrating: boolean;
	isV2MigrationStatusLoading: boolean;
};

export const useV2MigrationGuardStatus = ({
	currencyId,
	isMigrating,
	isV2MigrationStatusLoading
}: UseV2MigrationGuardStatusProps): GuardStatus => {
	const { data: currencies, isLoading: isCurrenciesLoading } = useCurrenciesQuery();

	const isLoading = isCurrenciesLoading || isV2MigrationStatusLoading;

	return useMemo(() => {
		if (isLoading) return 'loading';

		const currency = currencies?.find(currency => currency.id === currencyId);
		const isV1FT = currency?.type === 'nonDecimalVoteToken';

		return isMigrating && isV1FT ? 'denied' : 'allowed';
	}, [currencies, isMigrating, isLoading, currencyId]);
};
